import * as client_hooks from '../../../src-mobile/hooks.client.ts';


export { matchers } from './matchers.js';

export const nodes = [
	() => import('./nodes/0'),
	() => import('./nodes/1'),
	() => import('./nodes/2'),
	() => import('./nodes/3'),
	() => import('./nodes/4'),
	() => import('./nodes/5'),
	() => import('./nodes/6'),
	() => import('./nodes/7'),
	() => import('./nodes/8'),
	() => import('./nodes/9'),
	() => import('./nodes/10'),
	() => import('./nodes/11'),
	() => import('./nodes/12'),
	() => import('./nodes/13'),
	() => import('./nodes/14'),
	() => import('./nodes/15'),
	() => import('./nodes/16'),
	() => import('./nodes/17')
];

export const server_loads = [];

export const dictionary = {
		"/": [2],
		"/accounts": [3],
		"/cloud-mapping": [4],
		"/db-sync": [5],
		"/devices": [6],
		"/devices/claims/[claimId]": [8],
		"/devices/enroll": [9],
		"/devices/scan": [10],
		"/devices/[deviceId]": [7],
		"/edge-inventory": [11],
		"/events": [12],
		"/events/lookup": [14],
		"/events/[eventId]": [13],
		"/login": [15],
		"/settings": [16],
		"/sign-in": [17]
	};

export const hooks = {
	handleError: client_hooks.handleError || (({ error }) => { console.error(error) }),

	reroute: (() => {})
};

export { default as root } from '../root.svelte';